module.exports = __webpack_public_path__ + "img/a11y-large-text-1_cn.37de98f.jpg";